import { CanDeactivateFn } from "@angular/router";
import type { DashboardComponent } from "./dashboard.component";

/** Asks before leaving the dashboard with unsaved layout changes. */
export const dashboardUnsavedChangesGuard: CanDeactivateFn<DashboardComponent> = (component) =>
  component?.canDeactivate ? component.canDeactivate() : true;
